<template>
  <router-link
    :to="to"
    tag="span"
    class="logo-link"
    style="cursor: pointer"
  >
    <v-img
      :src="emcomyLogo"
      alt="emcomy - Emergency Communicator"
      max-width="250"
      class="logo"
    />
  </router-link>
</template>

<script>
  export default {
    name: 'LogoLink',
    props: {
      to: {
        type: String,
        default: '/',
      },
    },
    computed: {
      emcomyLogo() {
        const locale = this.$root.$i18n.locale
        if (locale === 'pt' || locale === 'ptBR') {
          return require('@/assets/emcomyLogo-pt.webp')
        }
        return require('@/assets/emcomyLogo.svg')
      },
    },
  }
</script>

<style scoped>
  .logo-link {
    display: block;
    width: 100%;
    max-width: 250px;
  }
</style>
